/* HALSTEAD — CRO add-ons
   1) sale countdown   2) reviews "show more"
   3) complementary suggestions: cart drawer + "Complete the look" on the product page
   4) fit finder: reasoning, select-size button, inch chart                          */
(function () {
  'use strict';

  if (window.__halCroBooted) return;
  window.__halCroBooted = true;

  var SUPPORT_EMAIL = 'info@halsteadmode.com';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ------------------------------------------------ 1. sale countdown */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initSale() {
    $$('[data-hal-sale]').forEach(function (box) {
      if (box.__halSale) return;
      box.__halSale = true;
      var end = Date.parse(box.getAttribute('data-end'));
      var out = $('[data-hal-sale-time]', box);
      if (!end || !out) return;
      var t;
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) { box.classList.add('is-over'); clearInterval(t); return; }
        var s = Math.floor(ms / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        box.classList.add('is-live');
      }
      t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ------------------------------------------ 2. reviews: show more */
  function initReviews() {
    $$('[data-hal-rv]').forEach(function (sec) {
      var btn = $('[data-hal-rv-more]', sec);
      if (!btn || btn.__hal) return;
      btn.__hal = true;
      btn.addEventListener('click', function () { sec.classList.add('is-expanded'); });
    });
  }

  /* ------------------------------------ 3. complementary suggestions */

  /* order matters: the first match wins */
  var CATS = [
    ['sets', /(\bsets?\b|\bsuits?\b|two-piece|three-piece|co-ord|tracksuit)/],
    ['shoes', /(boot|sandal|sneaker|trainer|loafer|heels?\b|pumps?\b|mule|slipper|shoe|derby|oxford|\bflats?\b)/],
    ['bags', /(\bbags?\b|tote|clutch|purse|backpack|wallet|handbag)/],
    ['jewelry', /(necklace|earring|bracelet|\brings?\b|pendant|\bwatch)/],
    ['accessories', /(scarf|scarves|\bwraps?\b|\bhats?\b|beanie|glove|\bbelts?\b|sunglass)/],
    ['dresses', /(dress|gown|jumpsuit|romper)/],
    ['outerwear', /(coat|jacket|parka|blazer|trench|puffer|overcoat|\bcapes?\b|gilet|\bvests?\b)/],
    ['knitwear', /(sweater|knit|cardigan|pullover|hoodie|turtleneck|jumper|sweatshirt)/],
    ['bottoms', /(pants?\b|trouser|jeans?\b|chino|shorts\b|legging|skirt)/],
    ['tops', /(blouse|shirt|\btops?\b|\btees?\b|t-shirt|polo|tunic|cami)/]
  ];

  var LABEL = {
    sets: 'Set', shoes: 'Shoes', bags: 'Bag', jewelry: 'Jewelry', accessories: 'Accessory',
    dresses: 'Dress', outerwear: 'Outerwear', knitwear: 'Knitwear', bottoms: 'Pants & skirts', tops: 'Top'
  };

  /* complementary collections per category: same audience, a different part of the outfit */
  var PAIRS = {
    w: {
      sets: ['women-pumps', 'women-bags', 'women-blouses', 'women-wool-coats'],
      dresses: ['women-heels', 'women-bags', 'women-wool-coats', 'jewelry-earrings'],
      outerwear: ['women-sweaters', 'women-boots', 'women-scarves', 'women-trousers'],
      knitwear: ['women-trousers', 'women-wool-coats', 'women-boots', 'women-scarves'],
      bottoms: ['women-sweaters', 'women-blouses', 'women-loafers', 'women-bags'],
      tops: ['women-trousers', 'women-cardigans', 'women-bags', 'jewelry-earrings'],
      shoes: ['women-bags', 'women-trousers', 'women-scarves', 'women-dresses'],
      bags: ['women-scarves', 'jewelry-earrings', 'women-loafers', 'women-wool-coats'],
      jewelry: ['women-scarves', 'women-bags', 'women-blouses', 'women-cardigans'],
      accessories: ['women-bags', 'jewelry-earrings', 'women-wool-coats', 'women-sweaters'],
      _default: ['women-bags', 'women-scarves', 'women-boots', 'jewelry-earrings']
    },
    m: {
      sets: ['men-shirts', 'men-dress-shoes', 'men-sneakers', 'men-coats'],
      outerwear: ['men-sweaters', 'men-pants', 'men-boots', 'men-shirts'],
      knitwear: ['men-trousers', 'men-jackets', 'men-dress-shoes', 'men-shirts'],
      bottoms: ['men-sweaters', 'men-shirts', 'men-sneakers', 'men-jackets'],
      tops: ['men-chinos', 'men-knitwear', 'men-jackets', 'men-sneakers'],
      shoes: ['men-pants', 'men-knitwear', 'men-jackets', 'men-shirts'],
      _default: ['men-knitwear', 'men-pants', 'men-jackets', 'men-shirts']
    }
  };

  function category(title, type) {
    var s = (String(title || '') + ' ' + String(type || '')).toLowerCase();
    for (var i = 0; i < CATS.length; i++) if (CATS[i][1].test(s)) return CATS[i][0];
    return '';
  }
  function gender(title, hint) {
    if (hint === 'men' || hint === 'm') return 'm';
    if (hint === 'women' || hint === 'w') return 'w';
    return /\b(men'?s|mens|man)\b/i.test(String(title || '')) ? 'm' : 'w';
  }
  function pairsFor(cat, sex) {
    var table = PAIRS[sex] || PAIRS.w;
    return table[cat] || table._default;
  }

  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var v = cents / 100;
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var comma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
              .replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/<[^>]*>/g, '');
  }
  function cents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return v;
    return Math.round(parseFloat(v) * 100) || 0;
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.split('?')[0] + '?width=' + w;
  }

  var collectionCache = {};
  function loadCollection(handle) {
    if (collectionCache[handle]) return collectionCache[handle];
    collectionCache[handle] = fetch(root() + 'collections/' + handle + '/products.json?limit=24', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d.products || []).map(normalise).filter(Boolean); })
      .catch(function () { return []; });
    return collectionCache[handle];
  }
  function normalise(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    if (!variants.length) return null;
    return {
      id: p.id,
      title: p.title,
      url: root() + 'products/' + p.handle,
      image: p.images && p.images[0] ? p.images[0].src : '',
      cat: category(p.title, p.product_type),
      variants: variants.map(function (v) {
        return { id: v.id, title: v.title, price: cents(v.price), compare: cents(v.compare_at_price) };
      })
    };
  }

  /* pick up to `max` products, one per complementary collection in turn,
     skipping what is already in the bag; `seed` rotates the picks per product */
  function suggest(cat, sex, exclude, max, seed) {
    var handles = pairsFor(cat, sex);
    return Promise.all(handles.map(loadCollection)).then(function (lists) {
      var picked = [], used = {};
      Object.keys(exclude || {}).forEach(function (k) { used[k] = true; });
      var offset = Math.abs(parseInt(seed, 10) || 0);
      for (var round = 0; round < 6 && picked.length < max; round++) {
        for (var i = 0; i < lists.length && picked.length < max; i++) {
          var list = lists[i];
          if (!list.length) continue;
          for (var k = 0; k < list.length; k++) {
            var p = list[(offset + round + k) % list.length];
            if (used[p.id]) continue;
            if (cat && p.cat === cat) continue;
            used[p.id] = true;
            picked.push(p);
            break;
          }
        }
      }
      return picked.slice(0, max);
    });
  }

  function variantControl(p, cls) {
    if (p.variants.length === 1) {
      return '<input type="hidden" value="' + p.variants[0].id + '" data-hal-up-variant>';
    }
    var opts = p.variants.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + v.compare + '">' + esc(v.title) + '</option>';
    }).join('');
    return '<select class="' + cls + '" aria-label="Choose option for ' + esc(p.title) + '" data-hal-up-variant>' + opts + '</select>';
  }
  function priceHtml(v) {
    return money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '');
  }

  function addToBag(btn, variantId, done) {
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        var added = res && res.items ? res.items[0] : res;
        btn.textContent = 'Added';
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        if (done) done();
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  function bindPriceSwitch(scope, itemSel, priceSel) {
    scope.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-hal-up-variant]');
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      var price = $(priceSel, sel.closest(itemSel));
      if (!o || !price) return;
      price.innerHTML = priceHtml({ price: parseInt(o.getAttribute('data-price'), 10), compare: parseInt(o.getAttribute('data-compare'), 10) });
    });
  }

  /* ---- 3a. cart drawer ---- */
  var MAX_UPSELL = 4;
  var busy = false, lastKey = '';

  function upsellHost() {
    var drawer = $('#CartDrawer');
    if (!drawer) return null;
    var box = $('[data-hal-upsell]', drawer);
    if (box) return box;
    var scroll = $('.drawer__inner .drawer__scrollable', drawer);
    if (!scroll) return null;
    box = document.createElement('div');
    box.className = 'hal-upsell';
    box.setAttribute('data-hal-upsell', '');
    box.hidden = true;
    scroll.appendChild(box);
    return box;
  }

  function nextTierText(count) {
    if (count === 1) return 'Add one more piece and 10% comes off both.';
    if (count === 2) return 'Add one more piece for 15% off everything.';
    if (count === 3) return 'Add one more piece for 20% off everything.';
    return 'Pieces chosen to go with what is in your bag.';
  }

  function renderUpsell(box, products, count) {
    if (!products.length) { box.hidden = true; box.innerHTML = ''; return; }
    var html = '<p class="hal-upsell__title">Complete the look</p>' +
      '<p class="hal-upsell__sub">' + esc(nextTierText(count)) + '</p><ul class="hal-upsell__list">';
    products.forEach(function (p) {
      var first = p.variants[0];
      html +=
        '<li class="hal-upsell__item">' +
          '<a class="hal-upsell__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 160)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="hal-upsell__body">' +
            (p.cat && LABEL[p.cat] ? '<span class="hal-upsell__cat">' + esc(LABEL[p.cat]) + '</span>' : '') +
            '<a class="hal-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="hal-upsell__price" data-hal-up-price>' + priceHtml(first) + '</span>' +
            '<div class="hal-upsell__row">' + variantControl(p, '') +
              '<button type="button" class="hal-upsell__add" data-hal-up-add>Add</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    });
    box.innerHTML = html + '</ul>';
    box.hidden = false;
  }

  function loadUpsell() {
    var box = upsellHost();
    if (!box || busy) return;
    busy = true;
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) { renderUpsell(box, [], 0); lastKey = ''; return null; }
        var inCart = {};
        items.forEach(function (i) { inCart[i.product_id] = true; });
        var anchor = items[0];
        var title = anchor.product_title || anchor.title;
        var cat = category(title, anchor.product_type);
        var sex = gender(title);
        var key = anchor.product_id + '|' + Object.keys(inCart).sort().join(',') + '|' + cart.item_count;
        if (key === lastKey && box.innerHTML) return null;
        lastKey = key;
        return suggest(cat, sex, inCart, MAX_UPSELL, anchor.product_id).then(function (list) {
          renderUpsell(box, list, cart.item_count || 0);
        });
      })
      .catch(function () { /* suggestions are optional — never break the bag */ })
      .then(function () { busy = false; });
  }

  function bindUpsell() {
    var drawer = $('#CartDrawer');
    if (!drawer || drawer.__halUp) return;
    drawer.__halUp = true;
    bindPriceSwitch(drawer, '.hal-upsell__item', '[data-hal-up-price]');
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-hal-up-add]');
      if (!btn) return;
      e.preventDefault();
      var v = $('[data-hal-up-variant]', btn.closest('.hal-upsell__item'));
      if (!v || !v.value) return;
      addToBag(btn, v.value, function () { setTimeout(function () { lastKey = ''; loadUpsell(); }, 450); });
    });
    var list = $('[data-products]', drawer);
    if (list && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(loadUpsell, 300); })
        .observe(list, { childList: true, subtree: true });
    }
    loadUpsell();
  }

  /* ---- 3b. "Complete the look" on the product page ---- */
  function initLook() {
    $$('[data-hal-look]').forEach(function (sec) {
      if (sec.__halLook) return;
      sec.__halLook = true;
      var grid = $('[data-hal-look-grid]', sec);
      if (!grid) return;
      var title = sec.getAttribute('data-title') || '';
      var cat = category(title, sec.getAttribute('data-type'));
      var sex = gender(title, sec.getAttribute('data-gender'));
      var self = {};
      self[sec.getAttribute('data-product-id')] = true;
      suggest(cat, sex, self, 4, sec.getAttribute('data-product-id')).then(function (list) {
        if (!list.length) { sec.hidden = true; return; }
        grid.innerHTML = list.map(function (p) {
          var first = p.variants[0];
          return '<li class="hal-ctl__card">' +
            '<a class="hal-ctl__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 480)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
            '<div class="hal-ctl__body">' +
              (p.cat && LABEL[p.cat] ? '<span class="hal-ctl__cat">' + esc(LABEL[p.cat]) + '</span>' : '') +
              '<a class="hal-ctl__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<span class="hal-ctl__price" data-hal-look-price>' + priceHtml(first) + '</span>' +
              '<div class="hal-ctl__row">' + variantControl(p, 'hal-ctl__select') +
                '<button type="button" class="hal-ctl__add" data-hal-look-add>Add to bag</button>' +
              '</div>' +
            '</div>' +
          '</li>';
        }).join('');
        sec.hidden = false;
      });
      bindPriceSwitch(sec, '.hal-ctl__card', '[data-hal-look-price]');
      sec.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-hal-look-add]');
        if (!btn) return;
        e.preventDefault();
        var v = $('[data-hal-up-variant]', btn.closest('.hal-ctl__card'));
        if (!v || !v.value) return;
        addToBag(btn, v.value);
      });
    });
  }

  /* --------------------------------------------- 4. fit finder add-ons */
  var CHART = {
    women: {
      cols: ['Size', 'Bust', 'Waist', 'Hips'],
      rows: [
        ['XXS', '31–32', '24–25', '34–35'],
        ['XS', '33–34', '26–27', '36–37'],
        ['S', '35–36', '28–29', '38–39'],
        ['M', '37–38½', '30–31½', '40–41½'],
        ['L', '39½–41', '32½–34', '42½–44'],
        ['XL', '42–44', '35–37', '45–47'],
        ['2XL', '45–47', '38–40', '48–50']
      ]
    },
    men: {
      cols: ['Size', 'Chest', 'Waist', 'Neck'],
      rows: [
        ['XS', '33–35', '27–29', '14–14½'],
        ['S', '36–38', '30–32', '15–15½'],
        ['M', '39–41', '33–35', '15½–16'],
        ['L', '42–44', '36–38', '16½–17'],
        ['XL', '45–47', '39–41', '17½–18'],
        ['2XL', '48–50', '42–44', '18½–19']
      ]
    }
  };
  var BUILD_WORDS = { slim: 'a slim build', average: 'an average build', curvy: 'a curvy build', full: 'a fuller build' };
  var FIT_WORDS = { close: 'a close fit', 'true': 'the fit as designed', relaxed: 'a roomy fit' };

  function normSize(s) {
    var t = String(s || '').trim().toUpperCase().replace(/\s+/g, '');
    if (t === 'XXL') return '2XL';
    if (t === 'XXXL') return '3XL';
    return t;
  }

  function sizeInputFor(size) {
    var sets = $$('.variant-input-wrap');
    for (var i = 0; i < sets.length; i++) {
      var h = ((sets[i].getAttribute('data-handle') || '') + ' ' + (sets[i].getAttribute('name') || '')).toLowerCase();
      if (!/size|größe|grosse|groesse|taille|talla/.test(h)) continue;
      var items = $$('.variant-input', sets[i]);
      for (var k = 0; k < items.length; k++) {
        if (normSize(items[k].getAttribute('data-value')) === normSize(size)) return $('input', items[k]);
      }
    }
    return null;
  }

  function closeFit(modal) {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function fixEmails(scope) {
    $$('a[href^="mailto:info@halstead.com"]', scope).forEach(function (a) {
      a.setAttribute('href', 'mailto:' + SUPPORT_EMAIL);
      if (/info@halstead\.com/.test(a.textContent)) a.textContent = SUPPORT_EMAIL;
    });
  }

  function enhanceResult(modal) {
    var out = $('[data-hal-result]', modal);
    if (!out) return;
    fixEmails(out);
    var badge = $('.hal-ff__badge', out);
    if (!badge || $('.hal-ff__reason', out)) return;
    var size = badge.textContent.trim();
    var mode = modal.getAttribute('data-mode') || 'apparel';
    var sex = modal.getAttribute('data-gender') === 'men' ? 'men' : 'women';

    /* 1. a reason in the customer's own terms */
    var reason = document.createElement('p');
    reason.className = 'hal-ff__reason';
    if (mode === 'shoes') {
      var shoe = $('#halShoeSize', modal);
      reason.innerHTML = 'You usually take <b>US ' + esc(shoe ? shoe.value : '') + '</b>, so we recommend <b>' + esc(size) + '</b> in this pair.';
    } else {
      var ft = parseInt(($('#halFt', modal) || {}).value, 10);
      var inch = parseInt(($('#halIn', modal) || {}).value, 10) || 0;
      var lbs = parseInt(($('#halLbs', modal) || {}).value, 10);
      var build = ($('input[name="build"]:checked', modal) || {}).value || 'average';
      var fit = ($('input[name="fit"]:checked', modal) || {}).value || 'true';
      reason.innerHTML = 'At ' + esc(ft) + '′' + esc(inch) + '″ and ' + esc(lbs) + ' lb, with ' + esc(BUILD_WORDS[build] || 'your build') +
        ' and ' + esc(FIT_WORDS[fit] || 'your preferred fit') + ', <b>' + esc(size) + '</b> is your best match.';
    }
    var why = $('.hal-ff__why', out);
    if (why) why.parentNode.insertBefore(reason, why); else out.appendChild(reason);

    /* 2. select the size without adding to the bag */
    var input = sizeInputFor(size);
    var add = $('[data-hal-add]', out);
    if (input && !input.classList.contains('disabled')) {
      var pick = document.createElement('button');
      pick.type = 'button';
      pick.className = 'btn hal-ff__pick';
      pick.textContent = 'Select size ' + size;
      pick.addEventListener('click', function () {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('click', { bubbles: true }));
        closeFit(modal);
      });
      if (add && add.parentNode) add.parentNode.insertBefore(pick, add.nextSibling);
      else out.appendChild(pick);
    }

    /* 3. inch chart, recommended row highlighted (apparel only) */
    if (mode !== 'shoes') {
      var c = CHART[sex];
      var rows = c.rows.map(function (r) {
        var rec = normSize(r[0]) === normSize(size);
        return '<tr' + (rec ? ' class="is-rec"' : '') + '>' + r.map(function (cell) { return '<td>' + cell + '</td>'; }).join('') + '</tr>';
      }).join('');
      var wrap = document.createElement('div');
      wrap.className = 'hal-ff__chartwrap';
      wrap.innerHTML = '<p class="hal-ff__charthead">Body measurements in inches</p>' +
        '<table class="hal-ff__chart"><thead><tr>' + c.cols.map(function (h) { return '<th>' + h + '</th>'; }).join('') + '</tr></thead><tbody>' + rows + '</tbody></table>' +
        '<p class="hal-ff__chartnote">Measure over light clothing. Garment measurements for this piece are in the Size &amp; fit tab.</p>';
      var help = $('.hal-ff__help', out);
      if (help) help.parentNode.insertBefore(wrap, help); else out.appendChild(wrap);
    }
  }

  function initFitPlus() {
    var modal = $('#HalFit');
    if (!modal || modal.__halPlus) return;
    modal.__halPlus = true;
    fixEmails(modal);
    var out = $('[data-hal-result]', modal);
    if (!out || !('MutationObserver' in window)) return;
    new MutationObserver(function () { enhanceResult(modal); }).observe(out, { childList: true });
  }

  function boot() {
    try { initSale(); } catch (e) {}
    try { initReviews(); } catch (e) {}
    try { bindUpsell(); } catch (e) {}
    try { initLook(); } catch (e) {}
    try { initFitPlus(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      try { initSale(); initReviews(); initLook(); initFitPlus(); } catch (e) {}
    }, 60);
  });
})();
